export const content = {
  navbar: {
    logoSrc: "images/logo.png",
    email: "hi@airguslar.com",
    bluesky: "https://bsky.app/profile/airguslar.com",
    mastodon: "https://mastodon.social/@airguslar",
  },
  //HOME
  home: {
    title: "Air Guslar",
    subtitle: "Games out of thin air",
    paragraph: "",
    models: [],
  },

  //PROJECTS
  projects: [
    {
      title: "Bump Bandit",
      description: "Laid-back jazzy puzzler",
      videoSrc: "./videos/bump-bandit.mp4",
      buttonText: "Play on Armor",
      buttonURL: "https://armorgames.com/bump-bandit-game/19579",
    },
    {
      title: "Shady Bears",
      description: "Frantic runner inspired by folklore",
      videoSrc: "./videos/shady-bears.mp4",
      buttonText: "Play on Poki",
      buttonURL: "https://poki.com/en/g/shady-bears",
    },
    {
      title: "Fixing Time",
      description: "You broke time. Fix it!",
      videoSrc: "./videos/fixing-time.mp4",
      buttonText: "Play on Poki",
      buttonURL: "https://poki.com/en/g/fixing-time",
    },
    {
      title: "Splitter",
      description: "Tiny dice game for 1 - 8 billion players",
      videoSrc: "./videos/splitter.mp4",
      buttonText: "Read more",
      buttonURL: "https://boardgamegeek.com/boardgame/349131/splitter",
    },
    {
      title: "Splitter ²",
      description: "The sequel to Splitter",
      videoSrc: "./videos/unknown.mp4",
      messageText: "Expected in 2026",
    },

    {
      title: "Gem 11",
      description: "Match your way to the 11th gem!",
      videoSrc: "./videos/gem-11.mp4",
      buttonText: "Play on Poki",
      buttonURL: "https://poki.com/en/g/gem-11",
    },
    {
      title: "Pair of Squares",
      description: "Place squares in pairs!",
      videoSrc: "./videos/pair-of-squares.mp4",
      buttonText: "Play on itch.io",
      buttonURL: "https://airguslar.itch.io/pair-of-squares",
    },
    {
      title: "Lords of Gomoku",
      description: "Five in a row, victory in tow!",
      videoSrc: "./videos/gomoku.mp4",
      buttonText: "Play on Poki",
      buttonURL: "https://poki.com/en/g/lords-of-gomoku",
    },
    {
      title: "Super Simple Solo",
      description: "Solo modes for various board games",
      videoSrc: "./videos/super-simple-solo.mp4",
      buttonText: "Full list",
      buttonURL: "https://linktr.ee/supersimplesolo",
    },
  ],
};
